<template>
  <div class="redirect-to-mayday-web-button">
    <el-tooltip
      :content="$t('knowledge.actions.go-to-web')"
      placement="left"
      class="group-tooltip"
    >
      <a class="icon-wrapper" :href="redirectToWeb" target="_blank">
        <font-awesome-icon :icon="['fal', 'external-link']" />
      </a>
    </el-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'web-redirection',
  data() {
    return {
      parametricRouteMapping: [
        {
          from: 'knowledge-home',
          to: 'web-filter',
        },
        {
          from: 'knowledge-filter',
          to: 'web-filter-results',
        },
        {
          from: 'knowledge-product',
          to: 'web-product',
        },
        {
          from: 'knowledge-content',
          to: 'web-content',
        },
        { from: 'knowledge-product-external', to: 'web-product-external' },
      ],
      webRouteMapping: [
        {
          from: 'knowledge-home',
          to: 'mayday-web-by-knowledge',
        },
        {
          from: 'knowledge-case',
          to: 'mayday-web-by-case',
        },
        {
          from: 'knowledge-content',
          to: 'mayday-web-by-content',
        },
        {
          from: 'knowledge-content-step',
          to: 'mayday-web-by-step',
        },
      ],
    };
  },
  computed: {
    routeMapping() {
      return this.isParametric
        ? this.parametricRouteMapping
        : this.webRouteMapping;
    },
    redirectToWeb() {
      const { name, params } = this.$route;

      const routeName = (
        this.routeMapping.find((mapping) => mapping.from === name) ||
        this.routeMapping[0]
      ).to;

      if (!this.focusKnowledge) return '/web';

      const routeData = this.$router.resolve(
        {
          name: routeName,
          params: {
            ...params,
            lang: this.editingLanguage,
            knowledgeId: this.focusKnowledge.id,
          },
        },
        this.$route,
      );
      return routeData.href;
    },
    ...mapGetters(['isParametric']),
    ...mapGetters('knowledgeModule', ['focusKnowledge', 'editingLanguage']),
  },
};
</script>

<style lang="scss" scoped>
.redirect-to-mayday-web-button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-wrapper {
  width: 24px;
  height: 24px;
  font-size: 14px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $grey-6-mayday;
  &:hover {
    background-color: $grey-2-mayday;
    color: $blue-mayday;
  }
}
</style>
